<template>
<div id="createJob">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Create New Job</h1>
    </div>
    <div class="container p-0" style="position: relative;">

        <div v-if="success" class="alert alert-success">{{success}}</div>

        <!-- Outer Row -->
        <div class="row justify-content-center">
            <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 p-0">
                <div class="o-hidden border-0">
                    <div class="p-0">
                        <!-- Nested Row within Card Body -->
                        <div class="py-2">
                            <form class="user" action autocomplete="off" @submit.prevent="submit()">
                                <div class="px-2">

                                    <div class="card mb-2 py-2 px-4">

                                        <h5 v-if="user.data.role > 3" class="m-0 pt-1 pb-2">Customer Contact Details</h5>
                                        <h5 v-if="user.data.role <= 3" class="m-0 pt-1">Your Contact Details</h5>
                                        <p v-if="user.data.role <= 3" class="mb-0"><small>To change these update your profile details</small></p>

                                        <!--<div class="form-group row" v-if="user.data.role > 3">
                                            <label for="jobid" class="col-md-3 col-form-label text-md-right">Organisation <small class="form-note">(If in system)</small></label>
                                            <div class="col-md-6">
                                                <select @change="onOrgChange($event)" v-model="form.organisation" name="dataTable_length" aria-controls="dataTable" class="custom-select form-control form-control-sm mb-2">
                                                    <option :value="null"></option>
                                                    <option :value="org" v-for="(org, i) in orgs" v-bind:key="i">{{org.name}}</option>
                                                </select>
                                            </div>
                                        </div>-->
                                        <div class="row" v-bind:class="{'form-group': user.data.role > 3}">
                                            <label for="business" class="col-md-3 text-md-right" v-bind:class="{'col-form-label': user.data.role > 3}">Business Name</label>
                                            <div class="col-md-6">
                                                <p v-if="user.data.role <= 3" class="m-0">{{job.company}}</p>
                                                <input v-if="user.data.role > 3" :disabled="form.organisation" id="business" type="text" class="form-control mb-2" name="business" v-model="job.company" />
                                            </div>
                                        </div>
                                        <div class="row required" v-bind:class="{'form-group': user.data.role > 3}">
                                            <label for="name" class="col-md-3 text-md-right" v-bind:class="{'col-form-label': user.data.role > 3}">Name</label>
                                            <div class="col-md-6">
                                                <p v-if="user.data.role <= 3" class="m-0">{{job.name}}</p>
                                                <input v-if="user.data.role > 3" id="name" type="text" class="form-control mb-2" name="name" required v-model="job.name" />
                                            </div>
                                        </div>
                                        <div class="row required" v-bind:class="{'form-group': user.data.role > 3}">
                                            <label for="phone" class="col-md-3 text-md-right" v-bind:class="{'col-form-label': user.data.role > 3}">Phone</label>
                                            <div class="col-md-3">
                                                <p v-if="user.data.role <= 3" class="m-0">{{job.phone}}</p>
                                                <input v-if="user.data.role > 3" id="phone" type="text" class="form-control mb-2" name="phone" required v-model="job.phone" />
                                            </div>
                                        </div>
                                        <div class="row required" v-bind:class="{'form-group': user.data.role > 3}">
                                            <label for="email" class="col-md-3 text-md-right" v-bind:class="{'col-form-label': user.data.role > 3}">Email</label>
                                            <div class="col-md-6">
                                                <p v-if="user.data.role <= 3" class="m-0">{{job.email}}</p>
                                                <input v-if="user.data.role > 3" id="email" type="email" class="form-control mb-2" name="email" required v-model="job.email" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card mb-2 py-2 px-4">

                                        <h5 class="m-0 pt-1">Job Items Inventory List</h5>
                                        <p><small>Please enter a description of your recyclable items or ebin type including a rough quantity.</small></p>

                                        <div class="form-group row">
                                            <label for="custJob" class="col-md-3 col-form-label text-md-right">Items List</label>
                                            <div class="col-md-9">

                                                <div class="row d-none d-none">
                                                    <div class="col-md-9"><label class="col-form-label">Description</label>
                                                    </div>
                                                    <div class="col-md-2"><label class="col-form-label">Quantity</label></div>
                                                    <div class="col-md-1"></div>
                                                </div>
                                                <div class="row mb-1" v-for="(item, i) in job.items" v-bind:key="i">
                                                    <div class="col-md-9"><input required placeholder="Description i.e Dell Desktop Computer or Samsung S10 Mobile" :id="'description'+i" type="text" class="form-control mb-1" :name="'description'+i" v-model="item.description" /></div>
                                                    <div class="col-md-2">
                                                        <input min="0" required placeholder="Qty" style="max-width:100px;" pattern="[0-9]*" inputmode="numeric" :id="'qty'+i" type="number" class="form-control mb-1" :name="'qty'+i" v-model="item.quantity" />
                                                    </div>
                                                    <div class="col-md-1"><button class="mt-1 btn btn-sm" @click="deleteItem(i)"><i class="fas text-danger fa-fw fa-trash"></i></button></div>
                                                </div>
                                                <button type="button" @click="addNewItem()" class="mt-1 btn btn-sm btn-secondary"><i class="fas fa-fw fa-plus"></i> Add New Item</button>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="card mb-2 py-2 px-4">
                                        <h5 class="mb-1 pt-1">Pickup Address</h5>
                                        <div class="form-group row required">
                                            <label for="site" class="col-md-3 col-form-label text-md-right">Address</label>
                                            <div class="col-md-7">

                                                <address-autocomplete classes="" :address.sync="job.address" />

                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="message" class="col-md-3 col-form-label text-md-right"> Address Note</label>
                                            <div class="col-md-7">
                                                <textarea placeholder="Enter any extra details about the pickup address" id="message" v-model="job.message" name="message" value="" class="form-control"></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card mb-2 py-2 px-4">

                                        <div class="form-group row mt-2">
                                            <label for="custJob" class="col-md-3 col-form-label text-md-right">Customer/Purchase Order #</label>
                                            <div class="col-md-3">
                                                <input id="from" type="text" class="form-control mb-2" name="custJob" v-model="job.custJob" />
                                            </div>
                                        </div>

                                        <div class="form-group row required">
                                            <label for="jobid" class="col-md-3 col-form-label text-md-right">Data Security</label>
                                            <div class="col-md-6">
                                                <h4 v-if="!eMode && job.jobid" class="pt-1 m-0">{{job.datadestruction}}</h4>
                                                <select v-if="eMode || !job.jobid" v-model="job.datadestruction" name="dataTable_length" required class="custom-select form-control mb-2">
                                                    <option :value="null">--Is Data Destruction Required?--</option>
                                                    <option value="No">No</option>
                                                    <option value="Erase">Erasure</option>
                                                    <option value="Shred">Shred</option>
                                                    <option value="Degauss">Degaussing</option>
                                                    <option value="Degauss & Shred">Degauss & Shred Combo</option>
                                                    <option value="NZISM">NZISM Disintegration</option>
                                                </select>
                                            </div>
                                        </div>

                                        <hr v-if="user.data.role > 3" />

                                        <div class="form-group row required" v-if="user.data.role > 3">
                                            <label for="jobid" class="col-md-3 col-form-label text-md-right">Assign Job To</label>
                                            <div class="col-md-4">
                                                <select v-model="form.assignedUser" name="dataTable_length" aria-controls="dataTable" class="custom-select form-control form-control-sm mb-2">
                                                    <option :value="null">Unassigned</option>
                                                    <option :value="user" v-for="(user, i) in users" v-bind:key="i">{{user.name}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <label for="note" class="col-md-3 col-form-label text-md-right">Additional Job Notes</label>
                                            <div class="col-md-6">
                                                <textarea placeholder="Enter addition notes" id="note" class="form-control" name="note" value v-model="form.note"></textarea>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div class="d-flex justify-content-center py-4">
                                    <button type="submit" id="sendlogin" class="btn btn-lg btn-primary">Save New Job</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    db
} from "../main";
import {
    mapGetters
} from "vuex";

import saveNoteMixin from "../mixins/saveNotes";
import AddressAutocomplete from "@/components/AddressAutocomplete";

const jobsRef = db.ref("jobs2020");
const jobCounterRef = db.ref("jobcounter");

export default {
    name: "InwardGoods",
    components: {
        AddressAutocomplete
    },
    mixins: [saveNoteMixin],
    data: function () {
        return {
            jobsRaw: [],
            limit: 10,
            //startAt: 0,
            maxLimit: 100000,
            endAt: 100000,
            jobOriginal: null,
            pageNo: 1,
            searchText: "",
            formStep: 0,
            eMode: false,
            form: {
                jobid: null,
                address: null,
                name: null,
                company: null,
                organisation: null,
                miscDrop: false,
                assignedUser: null,
                carrier: null,
                //datadestruction: null,
                numItems: null,
                weight: null,
                isTransfer: false,
                branch: parseInt(this.$route.query.branch),
                entered: null,
                note: null,
            },
            rwExpand: null,
            jobSearch: [],
            job: {},
            users: [],
            error: null,
            success: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user",
            orgs: "orgs"
        }),
        jobs: function () {
            return [...this.jobsRaw].reverse();
        },
        combinedWatch() {
            return this.limit + this.endAt;
        },
    },
    firebase: {
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(10),
    },
    methods: {
        onOrgChange(event) {
            console.log(event);
            const t = this;
            var org = t.form.organisation;
            if (org) {
                t.job.company = org.name;
                t.job.organisation = org['.key'];
            } else {
                t.job.company = "";
            }
        },
        clearOldStatus() {
            const t = this;
            t.success = null;
            t.error = null;
        },
        createNewJob() {
            const t = this;
            t.job = {
                datadestruction: null,
                items: [],
                itemoption: "manual",
                custJob: null,
                company: null,
                name: null,
                address: null,
            }
            if (t.user.data.role <= 3) { //Customer Completing this form
                t.job.name = t.user.data.name;
                t.job.email = t.user.data.email;
                t.job.phone = t.user.data.phone;
            }

            this.addNewItem();
        },
        deleteItem(i) {
            const t = this;
            console.log(t.job.items);
            console.log(typeof t.job.items);
            t.job.items.splice(i, 1);
            console.log(t.job.items);
        },
        addNewItem() {
            this.clearOldStatus();
            var item = {
                description: '',
                item: ''
            }
            this.job.items.push(item);
        },
        submit() {
            const t = this;
            console.log('job', t.job);

            /*const job = {
                ...t.job
            };*/
            var job = t.job;

            //First Get Job Id Counter value
            jobCounterRef.once('value', snapshot => {
                console.log('snap', snapshot.val())

                var newJobId = snapshot.val() + 1;
                //Final Job Fields
                job.jobid = newJobId;
                job.submitted = new Date().toISOString();
                job.enteredby = t.user.data.name; //t.form.entered.name;
                job.enteredUID = t.user.auth.uid; //t.form.entered['.key'];
                job.status = "Created";


                if (t.user.data.business) { //Customer Completing this form
                    return
                }

                if (t.form.assignedUser) {
                    job.assignedUID = t.form.assignedUser['.key'];
                    job.assignedTo = t.form.assignedUser.name;
                }

                //Push new job
                jobsRef
                    .push(job)
                    .then((snap) => {
                        console.log('job created!', snap);

                        //Update job counter value
                        jobCounterRef.set(newJobId)
                            .then(() => {
                                console.log('job counter updated!');
                                if (t.form.note) {
                                    t.saveNote(t.form.note.trim(), job, 'Note')
                                }
                                this.$router.push('Dashboard')
                            })

                    })
            })

        },
        resetForm() {
            console.log("Reseting the form");
            const t = this; //you need this because *this* will refer to Object.keys below`
            this.rwExpand = null;
            this.job = {};
            //Iterate through each object field, key is name of the object field`
            Object.keys(t.form).forEach(function (key) {
                if (key !== "branch" && key !== 'entered') {
                    t.form[key] = null;
                }
            });
            t.formStep = 0;
        },
    },
    created() {
        // this.selectedRow(12802);
        this.$store.dispatch('bindOrgs');
        this.createNewJob();
    },
};
</script>

<style>
.form-note {
    color: #999;
    display: block;
    font-size: 12px;
    margin: -4px 0 -12px;
}
</style>
